import { VoucherPrintOrgHeading, VoucherPrintOrgAddress, VoucherPrintDepartmentFooter } from "./VoucherPrintOrgHeader";
import PrintCommon from "app/common/Component/Print/PrintCommon";
import {
  format2NumberAtferComma,
  formatMoney,
  formatPrintPatientCodeSuffix,
  getDateTime,
  getSystemConfig,
  hideMiddleDigits,
} from "app/common/LocalFunction";
import { useStore } from "app/stores";
import React, { memo, useEffect, useState } from "react";
import QrSurveySection from "app/common/Component/Print/QrSurveySection";

const PrintVoucherTemporaryForm = ({
  componentRef,
  qrCode,
  listInvoiceItems,
  staffRevenues,
}) => {
  const totalValue =
    listInvoiceItems?.items?.length > 0 &&
    listInvoiceItems?.items?.reduce(
      (acc, curr) => {
        return {
          totalQuantity: acc.totalQuantity + (curr?.quantity || 0),
          totalPrice:
            acc.totalPrice + (curr?.price || 0) * (curr?.quantity || 0),
          totalAmount:
            acc.totalAmount + curr?.invoiceItem?.subAmountActuallyPaid,
          totalPaid: acc.totalPaid + curr?.invoiceItem?.subTotalBillPatientPaid,
          totalDebit:
            acc.totalDebit +
            (curr?.invoiceItem?.subAmountActuallyPaid -
              curr?.invoiceItem?.subTotalBillPatientPaid),
        };
      },
      {
        totalQuantity: 0,
        totalAmount: 0,
        totalPrice: 0,
        totalPaid: 0,
        totalDebit: 0,
      }
    );
  const namesText = staffRevenues
    ?.map((item) => item?.staff?.staffName)
    .join(" ; ");
  return (
    <PrintCommon ref={componentRef} marginPage="8mm" hidden={false}>
      <header className="printHeader w-100 flex justify-between">
        <table className="table-layout-fixed">
          <div className="wraper-print">
            <div className="container-print">
              <VoucherPrintOrgHeading department={listInvoiceItems?.department} />
              <VoucherPrintOrgAddress department={listInvoiceItems?.department} />

              <div className="mt-5 text-center">
                <h4 style={{ fontWeight: "bold", fontSize: "16px" }}>
                  HÓA ĐƠN TẠM TÍNH
                </h4>
                <div className="center">
                  {getDateTime(listInvoiceItems?.voucherDate)}
                </div>
              </div>

              <table
                className="info-print"
                style={{ width: "100%", borderCollapse: "collapse" }}
              >
                <tbody>
                  <tr>
                    <td
                      style={{
                        width: "30%",
                        fontWeight: "bold",
                        padding: "4px 0",
                      }}
                    >
                      KH:
                    </td>
                    <td
                      style={{
                        width: "70%",
                        padding: "4px 0",
                        fontWeight: "bold",
                      }}
                    >
                      {listInvoiceItems?.patientName || ""}{" "}
                      {formatPrintPatientCodeSuffix(listInvoiceItems?.patient, listInvoiceItems)}{" "}
                      {listInvoiceItems?.patient?.phoneNumber
                        ? `- ${hideMiddleDigits(listInvoiceItems?.patient?.phoneNumber)}`
                        : ""}
                    </td>
                  </tr>
                  <tr>
                    <td style={{ fontWeight: "bold", padding: "4px 0" }}>
                      Ngày:
                    </td>
                    <td style={{ padding: "4px 0", fontWeight: "bold" }}>
                      {getDateTime(listInvoiceItems?.voucherDate)}
                    </td>
                  </tr>
                  <tr>
                    <td style={{ fontWeight: "bold", padding: "4px 0" }}>
                      Tư vấn viên:
                    </td>
                    <td style={{ padding: "4px 0", fontWeight: "bold" }}>
                      {namesText}
                    </td>
                  </tr>
                  <tr>
                    <td style={{ fontWeight: "bold", padding: "4px 0" }}>
                      Thu ngân:
                    </td>
                    <td style={{ padding: "4px 0", fontWeight: "bold" }}>
                      {" "}
                      {listInvoiceItems?.accountant?.staffName || "Không rõ"}
                    </td>
                  </tr>
                  <tr>
                    <td style={{ fontWeight: "bold", padding: "4px 0" }}>
                      HĐ:
                    </td>
                    <td style={{ padding: "4px 0", fontWeight: "bold" }}>
                      {listInvoiceItems?.code || "Chưa có mã"}
                    </td>
                  </tr>
                </tbody>
              </table>

              <table className="table-print">
                <thead className="thead-print">
                  <tr>
                    <th>SL</th>
                    <th>Đ.Giá</th>
                    <th>KM</th>
                    <th>Thành tiền</th>
                  </tr>
                </thead>
                <tbody className="tbody-print">
                  {listInvoiceItems?.items?.length > 0 ? (
                    listInvoiceItems?.items?.map((it, index) => (
                      <React.Fragment key={it.id || index}>
                        <tr className="no-border">
                          <td colSpan={4} className="service-name-td">
                            {it?.content || "Không rõ"}
                          </td>
                        </tr>
                        <tr>
                          <td>{it?.quantity || 0}</td>
                          <td>{formatMoney(it?.price || 0)}</td>
                          <td>
                            {formatMoney(
                              it?.invoiceItem?.discount +
                              it?.invoiceItem?.allocateDiscount || 0
                            )}
                          </td>

                          <td>
                            {formatMoney(
                              it?.invoiceItem?.subAmountActuallyPaid || 0
                            )}
                          </td>
                        </tr>
                      </React.Fragment>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={4}>Không có dữ liệu</td>
                    </tr>
                  )}
                </tbody>
              </table>

              <table className="summary-table">
                <tbody>
                  <tr>
                    <td className="label-print">Tổng số lượng :</td>
                    <td className="value-print">{totalValue?.totalQuantity}</td>
                  </tr>
                  <tr>
                    <td className="label-print">Tiền hàng :</td>
                    <td className="value-print" style={{ fontWeight: "bold" }}>
                      {formatMoney(totalValue?.totalPrice)}
                    </td>
                  </tr>
                  <tr>
                    <td className="label-print">Tổng tiền (VNĐ):</td>
                    <td className="value-print" style={{ fontWeight: "bold" }}>
                      {formatMoney(totalValue?.totalAmount)}
                    </td>
                  </tr>
                  <tr>
                    <td className="label-print">Đã thanh toán :</td>
                    <td className="value-print" style={{ fontWeight: "bold" }}>
                      {formatMoney(
                        totalValue?.totalPaid -
                        listInvoiceItems?.moneyAfterDiscount
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td className="label-print">Khách hàng trả :</td>
                    <td className="value-print" style={{ fontWeight: "bold" }}>
                      {formatMoney(listInvoiceItems?.moneyAfterDiscount)}
                    </td>
                  </tr>
                  <tr>
                    <td className="label-print">Còn nợ :</td>
                    <td className="value-print" style={{ fontWeight: "bold" }}>
                      {formatMoney(totalValue?.totalDebit)}
                    </td>
                  </tr>
                  <tr>
                    <td className="label-print">Ghi chú :</td>
                    <td className="value-print">
                      {listInvoiceItems?.note || "Không có ghi chú"}
                    </td>
                  </tr>
                </tbody>
              </table>

              <div style={{ textAlign: "center", fontSize: "14px" }}>
                <span>Chữ ký khách hàng</span>
                <div style={{ height: "150px" }}></div>
              </div>

              <div style={{ textAlign: "center" }}>
                <div style={{ textAlign: "center", fontSize: "15px" }}>
                  <span>
                    Trung tâm Thẩm mỹ sẽ không hoàn lại tiền nếu khách hàng yêu
                    cầu hủy dịch vụ. Vui lòng liên hệ nếu có nhu cầu chuyển
                    nhượng.
                  </span>
                </div>
                <div className="mt-2">
                  <span style={{ fontSize: "14px" }}>Cảm ơn quý khách!</span>
                </div>
                <QrSurveySection
                  patient={listInvoiceItems?.patient}
                />
              </div>
              <div className="flex flex-center">
                <img src={qrCode} style={{ width: "124px" }} alt="QrCode" />
              </div>
            </div>
          </div>
        </table>
      </header>
    </PrintCommon>
  );
};

export default memo(PrintVoucherTemporaryForm);
